"use client";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import React from "react";
import { cn } from "@/lib/utils";
import dynamic from "next/dynamic";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import {
    BORDER_RADIUS_OPTIONS,
    FONT_SIZE_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";
const EditorComponent = dynamic(() => import("@/components/admin/BlockNote"), {
    ssr: false,
});
interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
    style: any;
    assets: IAccountAssets[];
    theme: IUserData["chosen_theme"];
}
export default function BlockRichText({
    edit,
    block,
    update,
    style,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={blockUpdate.show ? "" : "opacity-30"}
            title={"Rich Text Block"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                key={block.id}
                style={style}
                className={cn(
                    "w-full rounded-user bg-user-primary-color p-3 text-user-primary-text-color",
                    SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                    blockUpdate.style?.custom &&
                    BORDER_RADIUS_OPTIONS[blockUpdate.style.corner_radius]
                        ?.class,
                    blockUpdate.style?.custom &&
                    SHADOW_OPTIONS[blockUpdate.style.shadow]?.class,
                    blockUpdate.name.replaceAll(" ", "-"),
                    "block-" + block.id
                )}
            >
                {blockUpdate.style?.custom && (
                    <style>{`
            .rich-text-block-content-${block.id} {
                font-family: ${blockUpdate.style?.font} !important;
                font-size: ${FONT_SIZE_OPTIONS[blockUpdate.style.font_size]?.icon + "px"} !important;
                line-height:${FONT_SIZE_OPTIONS[blockUpdate.style.font_size]?.lineHeight} !important;
            };`}</style>
                )}
                <EditorComponent
                    value={blockUpdate.options.content}
                    id={block.id}
                    key={block.id}
                    readOnly
                    updateContent={blockUpdate.options.content}
                />
            </div>
        </AdminPopover>
    );
}
